import trainingReducer from './reducers';

export { default as trainingActions } from './actions';
export { default as trainingSelectors } from './selectors';
export default trainingReducer;
